import { Linking } from 'react-native';
import { showAlert } from '@/src/utils/alert';

export async function openURL(url: string): Promise<void> {
  try {
    await Linking.openURL(url);
  } catch {
    showAlert("Couldn't open link", 'Please try again later.');
  }
}

// Opens this app's settings page in the OS (iOS + Android), where the user can
// grant notification permission after a denial.
export async function openAppSettings(): Promise<void> {
  try {
    await Linking.openSettings();
  } catch {
    showAlert("Couldn't open settings", 'Please open Settings manually.');
  }
}

// The public site's origin — the base for links that LEAVE the app (share
// sheets today, deep links later). No fallback on purpose: a default would have
// to be production, and a build whose env didn't load would then hand people
// links to the wrong host without ever saying so.
//
// EXPO_PUBLIC_* vars are inlined by Babel at BUILD time, so this must stay a
// direct `process.env.X` reference — destructuring it or building the key
// dynamically reads an empty object at runtime.
const webBaseUrl = process.env.EXPO_PUBLIC_WEB_BASE_URL;

if (!webBaseUrl) {
  throw new Error(
    'EXPO_PUBLIC_WEB_BASE_URL is not set. Copy .env.example to .env (see that file for the value), then restart the bundler — env vars are inlined at build time, so a running bundler will not pick it up.'
  );
}

// Trailing slash stripped once here so the join below is the only place that
// decides on separators (and so TS keeps the non-undefined narrowing above,
// which it drops inside a function body).
const webOrigin = webBaseUrl.replace(/\/+$/, '');

/** An absolute URL on the public site, e.g. `webUrl('/events/42')`. */
export function webUrl(path: string): string {
  return `${webOrigin}/${path.replace(/^\/+/, '')}`;
}
